import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import axios from "@/libs/api.request";
import { xinli } from "./api_url";
/**
 * 新增机构
 * @param data
 * @returns {*|{responseURL}}
 */

export var company_add = function company_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.company_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 机构列表
 * @param {*} data
 * @returns
 */

export var company_list = function company_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.company_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 机构列表
 * @param {*} data
 * @returns
 */

export var company_update = function company_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.company_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除机构
 * @param {*} data
 * @returns
 */

export var company_del = function company_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.company_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 保存机构介绍
 * @param {*} data
 * @returns
 */

export var company_desc_save = function company_desc_save(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.company_desc_save,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增机构密码
 * @param {*} data
 * @returns
 */

export var companypass_add = function companypass_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.companypass_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 机构密码列表
 * @param {*} data
 * @returns
 */

export var companypass_list = function companypass_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.companypass_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑机构密码
 * @param {*} data
 * @returns
 */

export var companypass_update = function companypass_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.companypass_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除机构编码
 * @param {*} data
 * @returns
 */

export var companypass_del = function companypass_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.companypass_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除机构编码
 * @param {*} data
 * @returns
 */

export var companypass_file_upload = function companypass_file_upload(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.companypass_file_upload,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  }, "FormData");
};
/**
 * 获取咨询师列表
 * @param {*} data
 * @returns
 */

export var expert_list = function expert_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.expert_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增咨询师
 * @param {*} data
 * @returns
 */

export var expert_add = function expert_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.expert_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑咨询师
 * @param {*} data
 * @returns
 */

export var expert_update = function expert_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.expert_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除咨询师
 * @param {*} data
 * @returns
 */

export var expert_del = function expert_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.expert_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除专题
 * @param {*} data
 * @returns
 */

export var special_del = function special_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.special_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑专题
 * @param {*} data
 * @returns
 */

export var special_update = function special_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.special_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 专题列表
 * @param {*} data
 * @returns
 */

export var special_list = function special_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.special_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 专题列表添加
 * @param {*} data
 * @returns
 */

export var special_add = function special_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.special_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 获取密码列表和专题列表
 * @param {*} data
 * @returns
 */

export var get_testcat_password = function get_testcat_password(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.get_testcat_password,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 导入试题文件（xls或xlsx）
 * @param {*} data
 * @returns
 */

export var exam_import = function exam_import(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.exam_import,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  }, "FormData");
};
/**
 * 获取题库列表
 * @param {*} data
 * @returns
 */

export var exam_list = function exam_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.exam_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除题库
 * @param {*} data
 * @returns
 */

export var exam_del = function exam_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.exam_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 下载题库
 * @param {*} data
 * @returns
 */

export var exam_download = function exam_download(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.exam_download,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 评测记录列表
 * @param {*} data
 * @returns
 */

export var testlog_list = function testlog_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testlog_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 评测记录详情
 * @param {*} data
 * @returns
 */

export var testlog_detail = function testlog_detail(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testlog_detail,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 导出试卷
 * @param {*} data
 * @returns
 */

export var testlog_export = function testlog_export(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testlog_export,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 咨询师分析
 * @param {*} data
 * @returns
 */

export var tongji_expert = function tongji_expert(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.tongji_expert,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 专题分析
 * @param {*} data
 * @returns
 */

export var tongji_special = function tongji_special(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.tongji_special,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 用户分析
 * @param {*} data
 * @returns
 */

export var tongji_user = function tongji_user(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.tongji_user,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 导出数据详情
 * @param {*} data
 * @returns
 */

export var data_detail_export = function data_detail_export(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.data_detail_export,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 预约记录
 * @param {*} data
 * @returns
 */

export var appoint_list = function appoint_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.appoint_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 启用禁用
 * @param {*} data
 * @returns
 */

export var publicspecial_handle = function publicspecial_handle(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.publicspecial_handle,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 公开课列表
 * @param {*} data
 * @returns
 */

export var publicspecial_list = function publicspecial_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.publicspecial_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增公开课
 * @param {*} data
 * @returns
 */

export var publicspecial_add = function publicspecial_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.publicspecial_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 删除公开课
 * @param {*} data
 * @returns
 */

export var publicspecial_del = function publicspecial_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.publicspecial_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 编辑公开课
 * @param {*} data
 * @returns
 */

export var publicspecial_update = function publicspecial_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.publicspecial_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 导出测评记录
 * @param {*} data
 * @returns
 */

export var appoint_export = function appoint_export(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.appoint_export,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 上传图片
 * @param {*} data
 * @returns
 */

export var upload_pic = function upload_pic(data) {
  var country_code = localStorage.getItem("country_code");
  data.append("country_code", country_code);
  return axios.request({
    url: xinli.upload_pic,
    data: data,
    method: "post"
  }, "FormData");
};
/**
 * 审核预约记录
 * @param {*} data
 * @returns
 */

export var appoint_review = function appoint_review(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.appoint_review,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增分类
 * @param {*} data
 * @returns
 */

export var testcat_add = function testcat_add(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testcat_add,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增分类
 * @param {*} data
 * @returns
 */

export var testcat_list = function testcat_list(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testcat_list,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增分类
 * @param {*} data
 * @returns
 */

export var testcat_del = function testcat_del(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testcat_del,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};
/**
 * 新增分类
 * @param {*} data
 * @returns
 */

export var testcat_update = function testcat_update(data) {
  var country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testcat_update,
    data: _objectSpread({}, data, {
      country_code: country_code
    }),
    method: "post"
  });
};